import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import './style.css'; // Import your global styles or use module

const VideoPlayer = ({ buttons = [], width = '100%', height = '360px', url }) => {
  const ref = useRef(null);

  const str_pad_left = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  const minutesToSeconds = (n) => {
    const minutes = Math.floor(n);
    const seconds = (n % 1) * 60;
    return Math.round(seconds + minutes * 60);
  };

  const formatTime = (time) => {
    const totalSeconds = minutesToSeconds(time);
    const min = Math.floor(totalSeconds / 60);
    const sec = totalSeconds % 60;
    return `${str_pad_left(min, '0', 2)}:${str_pad_left(sec, '0', 2)}`;
  };

  const containerStyle = {
    padding: '10px',
  };

  const buttonsContainerStyle = {
    overflowY: 'auto',
    maxHeight: '45vh',
    width: width,
    padding: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  };

  const spanStyle = {
    display: 'block',
    color: '#aaa',
    margin: '10px 0 5px',
    fontWeight: '500',
    fontSize: '0.95rem',
    letterSpacing: 0.5,
  };

  const darkButtonStyle = {
    padding: '8px 14px',
    borderRadius: '6px',
    border: '1px solid #333',
    backgroundColor: '#242c38',
    color: '#f0f2f5',
    fontSize: '0.9rem',
    cursor: 'pointer',
    transition: 'background 0.2s ease',
  };

  const hoverStyle = {
    backgroundColor: '#32405b',
  };

  return (
    <div style={containerStyle}>
      <ReactPlayer
        ref={ref}
        url={url}
        playing
        controls
        width={width}
        height={height}
        config={{
          file: {
            attributes: { id: 'video-element' },
          },
        }}
      />

      {buttons.length > 0 && (
        <>
          <span style={spanStyle}>Navigate</span>
          <div style={buttonsContainerStyle}>
            {buttons.map((button, index) => (
              <button
                key={index}
                onClick={() => {
                  const seconds = minutesToSeconds(button.time);
                  if (ref.current) {
                    ref.current.seekTo(seconds, 'seconds');
                  }
                }}
                style={darkButtonStyle}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = darkButtonStyle.backgroundColor}
              >
                {button.label} ({formatTime(button.time)})
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default VideoPlayer;
